declare global {
    interface Window {
      gtag?: (...args: any[]) => void;
    }
  }
  
export const trackEvent = (eventName: string, category: string, label: string) => {
    window.gtag?.('event', eventName, {
      event_category: category,
      event_label: label
    });
  };
  
  export const trackNavigation = (label: string) => {
    trackEvent('navigation_click', 'navigation', label);
  };
  
  export const trackEngagement = (label: string) => {
    trackEvent('engagement_click', 'engagement', label);
  };
  
  export const trackExternalLink = (label: string) => {
    trackEvent('external_link_click', 'engagement', label);
  };